export default {
      id: "table-cell-border-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#table-cell-border-usage",
      toString: function () {
        return this.url;
      }
    }